import * as axios from 'axios';
import { randomString, log } from '@/common/utils';
import globalCache from '@/common/utils/global-cache';

let options = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
};
let instance = axios.create(options);
const isServer = process.server;

instance.defaults.xsrfCookieName = instance.defaults.xsrfHeaderName = '';

/**
 * 往响应数据中加入_updated字段
 * @param {*} rep 响应返回的拦截
 */
const addRepDataUpdated = (rep) => {
  // 只缓存get操作数据
  if (rep.config.method !== 'get' || !rep.data) return rep.data;

  const key = rep.config.url + JSON.stringify(rep.config.params);
  const cached = globalCache.get(key);
  const stringifyData = JSON.stringify(rep.data.data);
  const current = `${Date.now()}`;
  rep.data._updated = current;

  // 将数据存起，以获取更新时间
  if (cached) {
    // 数据与缓存数据不符，更新数据和更新时间
    if (cached.data !== stringifyData) {
      globalCache.set(key, {
        data: stringifyData,
        updated: `${Date.now()}`,
      });
    } else {
      rep.data._updated = cached.updated;
    }
  } else {
    globalCache.set(key, {
      data: stringifyData,
      updated: current,
    });
  }

  return rep.data;
};

let handler = {
  data: {},
  init(config) {
    let custom_key = `${config.url}-${Date.now()}-${randomString(20)}`;
    config.custom_key = custom_key;
    handler.data[custom_key] = {
      url: config.url,
      params: config.params,
      startTime: new Date().getTime(),
    };
  },
  print(config) {
    if (!isServer) {
      return;
    }
    let _data = handler.data[config.custom_key];
    if (_data && _data.startTime) {
      let time = new Date().getTime() - _data.startTime;
      let type = config.type;
      // 接口正常请求大于3秒，打印warn
      if (!type && time > 3000) {
        type = 'warn';
      }
      log(
        JSON.stringify({
          time: time + 'ms',
          status: config.status,
          ..._data,
        }),
        type
      );
      delete handler.data[config.custom_key];
    }
  },
};

instance.interceptors.request.use(
  function (config) {
    if (isServer && config && config.url) {
      handler.init(config);
    }
    return config;
  },
  function () {
    return Promise.reject({
      status: 0,
      statusText: 'REQUEST_ERROR',
    });
  }
);

instance.interceptors.response.use(
  function (rep) {
    if (rep && rep.data) {
      handler.print({
        status: `${rep.status} ${rep.statusText}`,
        ...rep.config,
      });

      return !process.server ? rep.data : addRepDataUpdated(rep);
    } else {
      handler.print({
        status: `${rep.status} return data null`,
        type: 'error',
        ...rep.config,
      });
      return null;
    }
  },
  function (rep) {
    let isTimeout = (rep || '').toString().indexOf('timeout') > -1;
    let status = isTimeout
      ? 'timeout'
      : rep.response
      ? `${rep.response.status} ${rep.response.statusText}`
      : 'error';
    handler.print({
      status,
      type: 'error',
      ...rep.config,
    });
    return Promise.reject({
      status: 0,
      statusText: isTimeout ? 'RESPONSE_TIMEOUT' : 'RESPONSE_ERROR',
      rep
    });
  }
);
export default instance;
